import "./CreditLine.css";
import { Trans, useTranslation } from "react-i18next";
import { i18n } from "../../../../i18n";
import { formatAmount, formatDate } from "../../../../format";
import { InfoOutlined } from "@mui/icons-material";
import Card, { CardText } from "../../../commons/Card/Card";
import { Gauge } from "@mui/x-charts";
import Typo from "../../../commons/Typo/Typo";

export default function CreditLine({
  available = 1,
  max = 2,
  currency = "EUR",
  date = "12-12-2012",
  stale = false,
}) {
  const { t } = useTranslation(["common", "financing"]);

  return (
    <div className="CreditLineSmall">
      <div
        style={{
          display: "flex",
          gap: "1rem",
          ...(stale
            ? {
                borderBottom: "var(--border)",
                paddingBottom: "0.5rem",
              }
            : {}),
          flexWrap: "wrap",
          alignItems: "stretch",
        }}
      >
        <div className="CreditLineSmall-title">
          <Typo>{t("financing:unlock.usecases.creditLine.title")}</Typo>
          <Typo className="CreditLineSmall-title-date">
            <Trans
              t={t}
              i18nKey="financing:unlock.usecases.creditLine.date"
              values={{
                date: formatDate(date, i18n.resolvedLanguage, "month-day"),
              }}
            />
          </Typo>
        </div>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <div className="CreditLineSmall-amounts">
            {formatAmount(available, i18n.resolvedLanguage, currency)} /{" "}
            {formatAmount(max, i18n.resolvedLanguage, currency)}
          </div>
          {stale && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <InfoOutlined style={{ color: "var(--color-warning-1)" }} />
            </div>
          )}
        </div>
      </div>

      {stale && (
        <div className="CreditLineSmall-stale">
          {t("financing:unlock.usecases.creditLine.stale")}
        </div>
      )}
    </div>
  );
}

export function Amount({ label, amount, warning = false, warningPhrase }) {
  return (
    <div className="Amount">
      <div
        style={{
          display: "flex",
          gap: "1rem",
          borderBottom: "var(--border)",
          paddingBottom: "0.5rem",
          alignItems: "stretch",
        }}
      >
        <div className="Amount-label">
          <Typo>{label}</Typo>
        </div>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <div className="Amount-value">{amount}</div>
          {warning && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <InfoOutlined style={{ color: "var(--color-warning-1)" }} />
            </div>
          )}
        </div>
      </div>

      {warning && <div className="Amount-warning">{warningPhrase}</div>}
    </div>
  );
}

export function CreditLineGauge({ available = 1, max = 2, currency = "EUR" }) {
  const { t } = useTranslation(["common", "financing"]);

  return (
    <Card className="CreditLineGaugeCard">
      <CardText heading={t("financing:unlock.usecases.creditLine.available")} />
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Gauge
          cornerRadius={"50%"}
          valueMin={0}
          valueMax={max}
          width={200}
          height={100}
          value={Math.max(available, 0)}
          startAngle={-90}
          endAngle={90}
        />
        <div className="CreditLineGaugeCard-available">
          {formatAmount(available, i18n.resolvedLanguage, currency)}
        </div>
        <div className="CreditLineGaugeCard-max">
          <Trans
            t={t}
            i18nKey="financing:unlock.usecases.creditLine.max"
            components={{
              label: <span className="CreditLineGaugeCard-max-label" />,
              value: <span className="CreditLineGaugeCard-max-value" />,
            }}
            values={{
              max: formatAmount(max, i18n.resolvedLanguage, currency),
            }}
          />
        </div>
      </div>
    </Card>
  );
}
